export default __webpack_public_path__ + "resources/icons/n141-e353.png";